import { DataImportStatusEnum } from 'graphql-common';

export default function isDataImportFinished(status: DataImportStatusEnum) {
  return (
    status === DataImportStatusEnum.Failed ||
    status === DataImportStatusEnum.Stopped ||
    status === DataImportStatusEnum.Complete ||
    status === DataImportStatusEnum.Interrupted
  );
}
